export default __webpack_public_path__ + "d8e602140731b9734e5641f1ac310897.png";